import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { IconButton, Icon, Panel } from 'rsuite'
import InputDataTableForm from '../../../components/forms/input/InputDataTableForm'
import InputDataTableView from '../../../components/forms/input/InputDataTableView'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import { getGoal, saveGoal, updateGoal, deleteGoal } from '../../../redux/actions/objectiveGoal'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getSchemaSidebar } from '../../../redux/actions/sidebar'
import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'

export default function GoalWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleUpdateSave = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      if (request.id) {
        console.log('call update.')
        response = await updateGoal(projectId, request.id, request)
      } else {
        console.log('call save.')
        response = await saveGoal(projectId, request)
      }
      console.log('response', response)

      if (response) {
        // setFormSchema(response.model.forms.goal)
        setFormSchema(response)
        try {
          await dispatch(getSchemaSidebar(projectId))
        } catch (e) {}
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async (schema) => {
    startLoading()
    setIsLoading(true)
    setIsDeleteError(false)
    try {
      console.log('call delete.')
      const status = await deleteGoal(projectId, schema.id)
      if (status === 200) {
        console.log('call get.')
        const _schema = await getGoal(projectId)
        console.log(('result', _schema))
        setFormSchema(_schema)
      } else {
        setIsDeleteError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsDeleteError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let dataList = [...formSchema.goal.value]
    let id
    if (data.selectedIndex != -1) {
      id = dataList[data.selectedIndex]?.id
    }

    handleUpdateSave({
      id: id,
      value: data.goal,
    })
  }

  const onDelete = (index) => {
    let dataList = [...formSchema.goal.value]
    handleDelete(dataList[index])
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

      {isEdit && showCommandButton ? (
        <InputDataTableForm
          key="key-goal"
          schema={formSchema.goal}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          onSubmit={handleSubmit(onSubmit)}
          onDelete={onDelete}
          isError={isError}
          isDeleteError={isDeleteError}
          loading={isLoading}
        />
      ) : (
        <InputDataTableView schema={formSchema.goal} />
      )}

      {showCommandButton && (
        <>
          <hr />

          {isEdit ? (
            <div>
              <IconButton
                appearance="ghost"
                className="rs-btn-ghost-info"
                icon={<Icon className="bt-gost-icon-radius-info" icon="backward" />}
                onClick={(e) => {
                  onChangeIsEdit(!isEdit)
                  setIsError(false)
                  setIsDeleteError(false)
                  scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
                }}
                disabled={isLoading}
              >
                {'ดูรายการ' + (formSchema.buttonText ? formSchema.buttonText : '')}
              </IconButton>
            </div>
          ) : (
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-edit"
              onClick={() => {
                onChangeIsEdit(!isEdit)
                setIsError(false)
                setIsDeleteError(false)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
              icon={<Icon className="bt-gost-icon-radius-edit" icon="edit" />}
              disabled={isLoading}
            >
              {'เพิ่ม/แก้ไข' + (formSchema.buttonText ? formSchema.buttonText : '')}
            </IconButton>
          )}
        </>
      )}
    </Panel>
  )
}
